export default __webpack_public_path__ + "static/The Home_Image 4_carousel 8@2x-ef848b0da6d4acd71e3fa0ededf08e1e.jpg";